// src/utils/color.js — Runway-inspired pure black + aurora
export const COLORS = {
  // Pure black backgrounds — cinema-grade dark
  background: {
    primary: '#000000',
    secondary: '#0A0A0A',
    tertiary: '#111111',
    elevated: '#1A1A1A',
    overlay: 'rgba(0, 0, 0, 0.92)',
  },

  // Primary = white — used for main CTA buttons only
  primary: {
    main: '#FFFFFF',
    light: '#F5F5F5',
    dark: '#CCCCCC',
    contrastText: '#000000',
  },

  // Aurora gradient — hero background accent ONLY, never on buttons/cards
  aurora: {
    gradient: 'linear-gradient(135deg, #7C3AED 0%, #4F46E5 40%, #0D9488 100%)',
    violet: '#7C3AED',
    indigo: '#4F46E5',
    teal: '#0D9488',
    glow: 'rgba(79, 70, 229, 0.15)',
  },

  // Text hierarchy
  text: {
    primary: '#FFFFFF',
    secondary: '#999999',
    tertiary: '#555555',
    muted: '#333333',
    accent: '#FFFFFF',
    disabled: '#2A2A2A',
  },

  // Status
  status: {
    success: '#22C55E',
    error: '#EF4444',
    warning: '#F59E0B',
    info: '#3B82F6',
    completed: '#22C55E',
    processing: '#F59E0B',
    failed: '#EF4444',
  },

  // Borders — extremely subtle
  border: {
    primary: 'rgba(255, 255, 255, 0.06)',
    secondary: 'rgba(255, 255, 255, 0.04)',
    subtle: 'rgba(255, 255, 255, 0.03)',
    focus: 'rgba(255, 255, 255, 0.3)',
    hover: 'rgba(255, 255, 255, 0.12)',
  },

  // Overlays
  overlay: {
    light: 'rgba(0, 0, 0, 0.4)',
    medium: 'rgba(0, 0, 0, 0.7)',
    heavy: 'rgba(0, 0, 0, 0.88)',
    dark: 'rgba(0, 0, 0, 0.96)',
  },

  // Hover states
  hover: {
    background: 'rgba(255, 255, 255, 0.04)',
    border: 'rgba(255, 255, 255, 0.12)',
  },

  // Shadows — pure black depth, no color
  shadows: {
    primary: '0 4px 24px rgba(0, 0, 0, 0.6)',
    secondary: '0 4px 16px rgba(0, 0, 0, 0.4)',
    card: '0 8px 32px rgba(0, 0, 0, 0.5)',
    button: '0 2px 12px rgba(0, 0, 0, 0.4)',
    large: '0 20px 60px rgba(0, 0, 0, 0.6)',
  },

  // Legacy aliases so nothing breaks during migration
  gradients: {
    primary: 'linear-gradient(135deg, #7C3AED 0%, #4F46E5 40%, #0D9488 100%)',
    secondary: '#999999',
    background: '#000000',
    card: '#111111',
    button: '#FFFFFF',
    buttonHover: '#F5F5F5',
    accent: 'linear-gradient(135deg, #7C3AED 0%, #0D9488 100%)',
  },

  secondary: {
    main: '#999999',
    light: '#CCCCCC',
    dark: '#555555',
    purple: '#7C3AED',
    gradient: '#999999',
  },
};

export const colorHelpers = {
  addAlpha: (color, alpha) =>
    `${color}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`,

  getStatusColors: (status) => {
    const baseColor = COLORS.status[status] || COLORS.status.info;
    return {
      backgroundColor: `${baseColor}18`,
      color: baseColor,
      border: `1px solid ${baseColor}40`,
    };
  },

  getButtonGradient: () => COLORS.primary.main,
  getHoverStyles: () => ({
    background: COLORS.primary.light,
    transform: 'translateY(-1px)',
    boxShadow: COLORS.shadows.button,
  }),
};

export default COLORS;
